import styled from 'styled-components';

export const Add = styled('button')`
  padding: 7px 16px 7px 21px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.orange400};
  border-radius: ${({ theme: { spacing } }) => spacing(21)};
  width: 100%;
  max-width: 460px;
  gap: ${({ theme: { spacing } }) => spacing(2.5)};
  img {
    flex: 0;
    width: 55px;
    height: 55px;
  }
  p {
    flex: 1;
  }
  span {
    flex: 0;
  }
  &:hover {
    background: ${({ theme }) => theme.palette.orange300};
  }
`;

export const Asset = styled('img')`
  width: 56px;
  height: 56px;
  flex: 0;
`;
